import { commitLocalUpdate } from "relay-runtime";
import environment from "../relay-environment";
/**
 * WARNING: Manipulating relay store manually has proven to be difficult and time consuming!
 * Solutions that use relay hooks are much more preferable and reliable.
 * Use this class only if working with client-only extensions like imessage or if you need to build a data bridge
 * between relay store and UI.
 */
export class Store {

  /**
   * The function generates a relay store imessage identifier. Since hello_message is not originated on IM server, its id has a different format to ensure uniqueness.
   * @param __id Relay auto-generated id of the vacancy record
   * @param message_id 
   * @returns 
   */
  public static getId(prefix: string, record_id: string, __id?: string) {
    return (record_id === '1')
      ? `custom:${prefix}:${__id}:${record_id}`
      : `custom:${prefix}:${record_id}`
  }

  public static SelectStream(select__id?: string, deselect__id?: string,) {

    // TODO ideally avoid low level manual store modifications and run graphql mutations with updater https://relay.dev/docs/guided-tour/list-data/updating-connections/
    // WARNING The alternative method of imperatively updating the store did not work because store.readUpdatableQuery does not exist on store in relay v15.
    // See more details on (non-working) readUpdatableQuery here https://relay.dev/docs/guided-tour/updating-data/imperatively-modifying-linked-fields/
    commitLocalUpdate(environment, store => {
      if (!select__id) {
        console.error(`Stream select__id is required.`)
        return
      }
      if (select__id == deselect__id) return

      // Select new stream
      const select_stream = store.get(select__id);
      if (!select_stream) throw new Error(`Stream ${select__id} does not exist in relay store.`)
      select_stream.setValue(true, 'selected')

      // Deselect old stream
      if (deselect__id) {
        // Get raw store records. They must exist since the caller have provided the stream __id.
        const deselect_stream = store.get(deselect__id);
        if (!deselect_stream) throw new Error(`Stream ${deselect__id} does not exist in relay store.`)
        deselect_stream.setValue(false, 'selected')
      }
    })
  }

}